import { CanActivateFn, Router } from '@angular/router';
import { TramiteService } from '../tramite.service';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import {AlertaModalService} from "../util/alerta-modal.service";

export const tramiteGuard: CanActivateFn = (route, state) => {
  const tramiteService = inject(TramiteService);
  const alertaModalService = inject(AlertaModalService);
  const router = inject(Router);

  const token = route.queryParams['token'];

  // Validar que existe el token
  if (!token) {
    alertaModalService.error(
      'Enlace inválido',
      'Por favor, usa el enlace enviado a tu correo.'
    );
    router.navigate(['/']);
    return false;
  }

  // Extraer tramiteId del token
  let tramiteId: string;
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    tramiteId = payload.tramiteId;
  } catch (error) {
    console.error('Error al decodificar token:', error);
    alertaModalService.error(
      'Enlace inválido',
      'El enlace está corrupto o no es válido.'
    );
    router.navigate(['/']);
    return false;
  }

  // Validar en backend
  return tramiteService.verificarCorreo(tramiteId, undefined, token).pipe(
    map((response) => {
      if (response.success) {
        return true;
      }
      alertaModalService.error(
        'Acceso denegado',
        'El enlace no es válido.'
      );
      router.navigate(['/']);
      return false;
    }),
    catchError(error => {
      console.error('Error al verificar:', error);

      if (error.status === 401) {
        alertaModalService.error(
          'Enlace expirado',
          'El enlace ha expirado o no es válido. Por favor, solicita uno nuevo.'
        );
      } else {
        alertaModalService.error(
          'Error de verificación',
          'Ocurrió un error al verificar el enlace. Por favor, intenta nuevamente.'
        );
      }

      router.navigate(['/']);
      return of(false);
    })
  );
};
